"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { CALC_LINKS } from "@/lib/routes";

export function NavLinks() {
  const pathname = usePathname();

  return (
    <nav className="hidden gap-6 md:flex">
      {CALC_LINKS.map(({ href, navLabel }) => {
        const isActive = pathname === href || pathname.startsWith(`${href}/`);
        return (
          <Link
            key={href}
            href={href}
            className={`text-sm font-medium transition-colors hover:text-foreground ${
              isActive ? "text-foreground" : "text-muted-foreground"
            }`}
          >
            {navLabel}
          </Link>
        );
      })}
    </nav>
  );
}
